import type {
  TableCallParticipantCallData,
  TableCallStatePayload,
} from "@bezoned/desktop-bridge/table-call-messaging.js";

import type { LocalCallPhase } from "../../table-call/table-call-participant-directory.js";
import type {
  TableCallAudioReadiness,
  TableCallStatus,
} from "../../table-call/table-call.context.js";
import { mapTableCallStatus } from "./participant-state-builder.js";

export const buildRecoveryStatePayload = ({
  status,
  selfUserId,
  selfName,
  microphoneActive,
  canControlMicrophone,
  sessionPhase,
  audioReadiness,
  participants,
}: {
  status: TableCallStatus;
  audioReadiness: TableCallAudioReadiness;
  selfUserId: string;
  selfName: string;
  microphoneActive: boolean;
  canControlMicrophone: boolean;
  sessionPhase: LocalCallPhase;
  participants: TableCallParticipantCallData[];
}): Omit<TableCallStatePayload, "projectionSequence"> => ({
  audioReadiness,
  participants,
  self: {
    audioReadiness,
    canControlMicrophone,
    displayName: selfName,
    microphoneActive,
    sessionPhase,
    userId: selfUserId,
  },
  status: mapTableCallStatus(status),
});
